import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { PATHS } from 'src-ironside/app-routing.module';
import { PartnerRepository } from 'src-ironside/repositories/partner.repository';
import { ResourceRepository } from 'src-ironside/repositories/resource.repository';
import { BreadCrumbItem } from 'src-ironside/shared/components/bread-crumb/bread-crumb.component';

@Component({
    selector: 'app-partners-detail',
    templateUrl: 'partners-detail.component.html',
    styleUrls: ['./partners-detail.component.css'],
    providers: [PartnerRepository, ResourceRepository],
})
export class PartnersDetailComponent {
    readonly unsubscribe$ = new Subject();

    contacts: any;
    partner: any;
    partnerCode: string = '';

    constructor(
        private activateRoute: ActivatedRoute,
        private partnerRepository: PartnerRepository,
        private translate: TranslateService
    ) {
        this.partnerCode = this.activateRoute.snapshot.paramMap.get('code') || '';
    }

    ngOnInit() {
        this.getPartner();
    }

    get breadCrumb() {
        let breadCrumbs: BreadCrumbItem[] = [
            { name: this.translate.instant('Menu.home'), url: PATHS.home_en },
            { name: this.translate.instant('Menu.the-partners'), url: PATHS.partners_en },
        ];

        return breadCrumbs;
    }

    getPartner() {
        this.partnerRepository
            .getDetailPartner(1, 150, 'DESC', this.partnerCode)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res) => {
                if (res[0]?.linkToNaturalPersons && res[0]?.linkToNaturalPersons?.length > 0) {
                    this.partnerRepository
                        .getContacts(
                            res[0]?.linkToNaturalPersons.map((contact: any) => contact.documentId)
                        )
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe({
                            next: (contacts) => {
                                this.contacts = contacts.filter(
                                    (contact: any) => contact.status?.value === 'ACTIF'
                                );
                            },
                        });
                }

                this.partner = res[0];
                this.partner.logo = res[0]?.logo?.[0]?.url ?? '';
                this.breadCrumb.push({ name: this.partner.companyName });
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
